<script>
    import { format, subMinutes, isBefore } from 'date-fns';

    import modals from '../state/modals';
    import user from '../state/user';
    import time from '../state/time';

    let saveError = null;

    let newPerson = {
        name: '',
        phone: ''
    };

    let saving = false;
    let userProfile = {
        name: '',
        phone: ''
    };
    $: onUserLoaded($user);
    function onUserLoaded(user) {
        if (!user) return;

        userProfile.name = user.cln_name;
        userProfile.phone = formatPhone(user.cln_phone);
    }

    async function onUpdate() {
        saving = true;
        let res = await user.updateDetails(userProfile.name, userProfile.phone);
        saving = false;

        if (res && res.status) {
            $user.cln_name = userProfile.name;
            $user.cln_phone = userProfile.phone;
        }
    }

    let addingNewPerson = false;
    async function onAddNewPerson() {
        addingNewPerson = true;
        let res = await user.addSub(newPerson.name, newPerson.phone);
        addingNewPerson = false;

        if (res && res.status) {
            $user.subs = res.subs;

            // Reset form
            newPerson['name'] = newPerson['phone'] = '';
        }
    }

    function closeModal(e) {
        modals.toggleProfileModal(false);
    }

    function formatDate(date) {
        return format(date, 'D. M. YYYY');
    }

    function formatDateTime(date) {
        return format(date, 'D. M. YYYY H:mm');
    }

    function formatTime(date) {
        return format(date, 'H:mm');
    }

    function formatPhone(phone) {
        let out = [];

        if (!phone) return '';

        // Remove formatting
        phone = phone.replace(/[^0-9+]/g, '');

        while (phone.length > 0) {
            // Consume up to 3 numbers from the end
            phone = phone.replace(/.{1,3}$/, part => {
                out.unshift(part);
                return '';
            });
        }

        return out.join(' ').replace('+ ', '+');
    }

    function cleanupPhone() {
        let phone = userProfile.phone.replace(/[^0-9+]/, '');

        // TODO: More cleanup

        userProfile.phone = formatPhone(phone);
    }

    function getMaxCancelTime(event) {
        // TODO: Replace with db value
        return subMinutes(event.evr_from, 60 * 3); // 3 hours
    }

    function canCancel(event, now) {
        // Cannot cancel free events
        if (event.res_price == 0 || event.res_credits == 0) return false;

        let maxTime = getMaxCancelTime(event);
        return isBefore(now, maxTime);
    }

    function isExpired(cre, now) {
        if (!cre.cre_expiration) {
            return false;
        }

        return !isBefore(now, cre.cre_expiration);
    }
</script>

<style>
    /* .modal-card-foot { padding: 38px 20px; } */

    .modal-card-body { border-radius: 0 0 6px 6px; }

    .title {
        margin: 25px 0 10px;
    }

    .title:first-child { margin-top: 0; }
    .title:last-child { margin-bottom: 0; }

    .striked {
        text-decoration: line-through;
    }
</style>

{#if $user && $modals.profile_opened}
    <div class="modal" class:is-active={$modals.profile_opened}>
        <div class="modal-background" on:click={closeModal}></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <div class="modal-card-title">Váš profil</div>
                <button class="delete" aria-label="Zavřít" on:click={closeModal}></button>
            </header>
            <section class="modal-card-body">
                <h2 class="title">Uživatel</h2>
                <form on:submit|preventDefault={onUpdate}>
                    {#if saveError}
                        <article class="message is-danger">
                            <div class="message-body">{saveError}</div>
                        </article>
                    {/if}

                    <!-- <div class="field">
                        <label class="label" for="userEmail">Email</label>
                        <div class="control">
                            <input bind:value={$user.cln_email} class="input" id="userEmail" type="email" placeholder="vas@email.cz" readonly required>
                        </div>
                    </div> -->

                    <div class="field">
                        <label class="label" for="userName">Jméno</label>
                        <div class="control">
                            <input bind:value={userProfile.name} class="input" id="userName" type="text" placeholder="Vaše jméno" required>
                        </div>
                    </div>

                    <div class="field">
                        <label class="label" for="userPhone">Telefon</label>
                        <div class="control">
                            <input bind:value={userProfile.phone} class="input" id="userPhone" type="text" placeholder="Telefonní číslo" on:change={cleanupPhone} maxlength="16" required>
                        </div>
                    </div>

                    <button class="button is-primary" disabled={saving}>Uložit</button>

                    <!-- <div class="field">
                        <label class="label" for="userPassword">Heslo</label>
                        <div class="control">
                            <input value='' class="input" id="userPassword" type="password" placeholder="Vaše heslo" readonly required>
                        </div>
                    </div> -->
                </form>

                <h2 class="title">Rezervace</h2>
                <table class="table is-fullwidth">
                    <thead>
                        <tr>
                            <th>Lekce</th>
                            <th>Začátek - konec</th>
                            <th>Rezervováno</th>
                            <th>Zaplaceno</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each $user.reservations as res (res.res_id)}
                            <tr>
                                <td>{res.evn_title}</td>
                                <td>
                                    {formatTime(res.evr_from)} - {formatTime(res.evr_to)}<br>
                                    {formatDate(res.evr_from)}
                                </td>
                                <td>
                                    {formatDateTime(res.res_created)}<br>

                                    {#if res.res_canceled == 0 && canCancel(res, $time.now)}
                                        <a href="/zrusit/{res.res_id}/{res.res_code}" class="button is-danger is-small">Zrušit</a>

                                        <!-- <small>{formatDateTime(getMaxCancelTime(res))}</small> -->
                                    {/if}
                                </td>
                                <td>
                                    {#if false && res.res_canceled > 0}
                                        Zrušena
                                    {:else if res.res_paid > 0}
                                        Ano<br>
                                        {res.res_price} Kč
                                    {:else if res.res_paidWithCredits > 0}
                                        Ano<br>
                                        {res.res_credits} kredit(y)
                                    {:else if res.res_price == 0 || res.res_credits == 0}
                                        Zdarma
                                    {:else}
                                        <a class="button is-small is-primary" href="/platba/r{res.res_id}/{res.res_code}" target="_blank">Zaplatit</a>
                                    {/if}
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
                <article class="message is-small is-info">
                    <div class="message-body">Zobrazujeme pouze posledních 10 rezervací.</div>
                </article>

                <h2 class="title">Kredity</h2>
                <table class="table is-fullwidth">
                    <thead>
                        <tr>
                            <th>Množství</th>
                            <th>Zbývající</th>
                            <th>Platné do</th>
                            <th>Zaplaceno</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each $user.creditList as cre (cre.cre_id)}
                            <tr>
                                <td>{cre.cre_amount}</td>
                                <td class:striked={isExpired(cre, $time.now)}>{cre.cre_amount - cre.used}</td>
                                <td>{formatDate(cre.cre_expiration)}</td>
                                <td>
                                    {#if cre.cre_canceled > 0}
                                        Zrušeno
                                    {:else if cre.paid > 0}
                                        Ano ({cre.pay_value} Kč)
                                    {:else}
                                        <a class="button is-small is-primary" href="/platba/k{cre.cre_id}/{cre.cre_code}" target="_blank">Zaplatit</a>
                                    {/if}
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                </table>

                <h2 class="title">Další osoby</h2>
                <table class="table is-fullwidth">
                    <thead>
                        <tr>
                            <th>Jméno</th>
                            <th>Telefon</th>
                        </tr>
                    </thead>

                    <tbody>
                        {#if $user.subs && $user.subs.length}
                            {#each $user.subs as sub}
                                <tr>
                                    <td>{sub.cln_name}</td>
                                    <td>{sub.cln_phone}</td>
                                </tr>
                            {/each}
                        {/if}
                    </tbody>
                </table>

                <form on:submit|preventDefault={onAddNewPerson}>
                    <div class="columns">
                        <div class="column">
                            <div class="field">
                                <label for="additionalName" class="label">Jméno</label>
                                <div class="control">
                                    <input class="input" type="text" placeholder="Další osoba" id="additionalName" name="fname" bind:value={newPerson.name} required>
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <label for="additionalPhone" class="label">Telefon</label>
                                <div class="control">
                                    <input class="input" type="text" placeholder="Telefon" id="additionalPhone" name="phone" bind:value={newPerson.phone} required>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button class="button is-primary" disabled={addingNewPerson}>Přidat další osobu</button>
                </form>
            </section>

            <!-- <footer class="modal-card-foot"></footer> -->
        </div>
    </div>
{/if}